const rolloverHeading = async function () {
    if ( document.querySelector(".heading-rollover") ) {

        const rollover = document.querySelectorAll(".heading-rollover");

        rollover.forEach(element => {
            const wrapper = element.querySelector(".heading-rollover-wrapper"),
             content = element.querySelector(".heading-rollover-content"),
             showContents = element.querySelectorAll(".heading-rollover-show-content"),
             colors = element.querySelectorAll(".heading-rollover-color"),
             btn = element.querySelector(".heading-rollover-btn");
            
            let isOpen = false;

            if (wrapper && content && btn) {
                const init = () => {
                    wrapper.classList.add('transition-all', 'overflow-hidden', 'relative');
                    content.classList.add('transition-opacity', 'invisible', 'opacity-0');
                    btn.classList.add('transition-transform', 'transform', 'absolute');

                    if ( colors ) {
                        colors.forEach(color => {
                            color.classList.add('transition-colors');
                        });
                    }
                    
                    if ( showContents ) {
                        showContents.forEach(content => {
                           content.classList.add('opacity-0', 'invisible');
                        });
                    }
                }

                const open = () => {
                    isOpen = true;
                    wrapper.classList.add("bg-blue");

                    content.classList.remove("invisible");
                    content.classList.remove("opacity-0");

                    btn.classList.add("rotate-45");

                    if ( showContents ) {
                        showContents.forEach(content => {
                            content.classList.remove("invisible");
                            content.classList.remove("opacity-0");
                        });
                    }

                    if ( colors ) {
                        colors.forEach(color => {
                            color.classList.add('text-blue');
                        });
                    }
                }

                const close = () => {
                    isOpen = false;
                    wrapper.classList.remove("bg-blue");

                    content.classList.add("invisible");
                    content.classList.add("opacity-0");

                    btn.classList.remove("rotate-45");

                    if ( colors ) {
                        colors.forEach(color => {
                            color.classList.remove('text-blue');
                        });
                    }

                    if ( showContents ) {
                        showContents.forEach(content => {
                            content.classList.add("invisible");
                            content.classList.add("opacity-0");
                        });
                    }
                }
                
                window.addEventListener("resize", () => {
                    if ( window.innerWidth >= 768 ) close();
                });

                init();

                btn.addEventListener("click", () => {

                    if ( isOpen ) {
                        close();
                    } else {
                        open();
                    }
                });
            }

        });
    }
}

export const init = rolloverHeading;